<template>

    <trax-ui-card-icon-header 
        :icon="icon" :header-color="headerColor" :title="title" v-show="atp_proposal">

            <trax-ui-html :placeholder="lang.polaris.procedure.atp_response"
                v-model="atp_proposal" col="md-3">
            </trax-ui-html>

            <trax-ui-html :placeholder="lang.polaris.procedure.atp_result" v-show="atp_result"
                v-model="atp_result" col="md-3">
            </trax-ui-html>

    </trax-ui-card-icon-header>

</template>

<script>
    export default {
    
        props: {
            id: {default: 'enac-procedure-atp-daf-edit'},
            icon: null,
            headerColor: null,
            title: null
        },

        data: function() {
            return {
                lang: lang,
                atp_proposal: '',
                atp_result: null,
                bus: this.$bus
            }
        },
        
        created: function() {
            this.bus.$on(this.id+'-data', this.setData);
            this.bus.$on(this.id+'-updated', this.setData);
        },

        methods: {

            setData(procedure) {
                if (procedure.data.atp_proposal) this.atp_proposal = procedure.data.atp_proposal.comments;
                if (procedure.data.atp_result) this.atp_result = procedure.data.atp_result.comments;
            }
        }
    }
</script>
